<template>
    <section class="openAccountPart">
  <img
    class="leftShadow pc"
    src="@/assets/image/trading-product/section3-shadow-left.png"
    alt=""
  />
  <img
    class="topShadow mobile"
    src="@/assets/image/trading-product/section3-shadow-top.png"
    alt=""
  />
    <img
    class="openAccountBg pc"
    src="@/assets/image/trading-product/openAccountBg.png"
    alt=""
  />
  <div class="contentBox">
    <h2 class="title-48_bold md-title-24_bold scroll-fade-up">如何申请PAMM账户</h2>
    <div class="mobile">
      <a :href="signupUrl" target="_blank">
        <div class="iBtn primary-default_large scroll-fade-up">立即申请</div>
      </a>
    </div>
    <div class="cardList flex scroll-fade-up">
      <div class="card flex justify-center items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="405"
          height="132"
          viewBox="0 0 405 132"
          fill="none"
        >
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0H357L405 66L357 132H16C7.16344 132 0 124.837 0 116V16Z"
            fill="white"
          />
        </svg>
        <div class="num">1</div>
        <div class="rightWord">
          <div class="top title-24_bold md-subtitle-18_medium">注册账户</div>
          <div class="bottom body-16_regular md-footnote-regular_12">
            提交基本信息，创建交易账号
          </div>
        </div>
      </div>
      <div class="card flex justify-center items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="453"
          height="132"
          viewBox="0 0 453 132"
          fill="none"
        >
          <path d="M0 0H405L453 66L405 132H0L48 66L0 0Z" fill="white" />
        </svg>
        <div class="num">2</div>
        <div class="rightWord">
          <div class="top title-24_bold md-subtitle-18_medium">
            提交申请
          </div>
          <div class="bottom body-16_regular md-footnote-regular_12">
            按账号类型入金，签署协议
          </div>
        </div>
      </div>
      <div class="card flex justify-center items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="405"
          height="132"
          viewBox="0 0 405 132"
          fill="none"
        >
          <path
            d="M0 0H389C397.837 0 405 7.16344 405 16V116C405 124.837 397.837 132 389 132H0L48 66L0 0Z"
            fill="white"
          />
        </svg>
        <div class="num">3</div>
        <div class="rightWord">
          <div class="top title-24_bold md-subtitle-18_medium">绑定PAMM账户</div>
          <div class="bottom body-16_regular md-footnote-regular_12">
            完成绑定，即可查看账户信息
          </div>
        </div>
      </div>
    </div>
    <div class="pc">
      <a :href="signupUrl" target="_blank">
        <div class="iBtn primary-default_large scroll-fade-up">立即申请</div>
      </a>
    </div>
  </div>
  <img
    class="rightShadow pc"
    src="@/assets/image/trading-product/section3-shadow-right.png"
    alt=""
  />
  <img
    class="bottomShadow mobile"
    src="@/assets/image/trading-product/section3-shadow-bottom.png"
    alt=""
  />
</section>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    computed: {

        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>
<style scoped>
  .contentBox{
    max-width: 1200rem;
    margin-inline:auto;
  }  .openAccountPart {
        
    padding: 120rem 0;
    position: relative;
    background:#f7f7f7;
  }
  .openAccountPart .leftShadow {
    width: 37vw;
opacity:.5;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
  .openAccountPart .rightShadow {
    width: 37vw;
opacity:.5;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
  }
  .openAccountPart h2,
  .openAccountPart h3 {
    text-align: center;
    margin-bottom: 60rem;
  }
  .openAccountPart h3 {
    margin: 16rem 0 60rem;
    color: var(--ebc-text-secondary);
  }
.openAccountPart .openAccountBg{
    position: absolute;
    width: 1000rem;
    height: 460rem;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
  }
@media (max-width:996px){
   .openAccountPart .openAccountBg{
     display:none;
}
}

  .openAccountPart .cardList .card {
    position: relative;
    gap: 20rem;
    height: fit-content;min-height:132rem;padding-inline:50rem;
    flex: 1 0 405rem;
    z-index: 1;
    border:0;
    background: transparent;
  }
  .openAccountPart .cardList .card .top{
    white-space: nowrap;
  }
  .openAccountPart .cardList .card:nth-child(2) {
    flex: 1 0 453rem;
    margin-inline: -31rem;
  }
  .openAccountPart .cardList .card > svg {
    position: absolute;
    width: 100%;
    z-index: -1;
  }
  .openAccountPart .cardList .card:nth-child(1) .num{
      margin-right: 8rem;
    }
  .openAccountPart .cardList .card .num {
    font-size: 75rem;
    color: var(--ebc-brand-secondary-red);
    font-weight: 700;
  }
  .openAccountPart .cardList .card .rightWord .bottom {
    margin-top: 8rem;
    color: var(--ebc-text-secondary);
  }
 .openAccountPart .iBtn {
    margin: 60rem auto 0;
    min-width: 180rem;
    width: fit-content;
  }
  .openAccountPart .contentBox {
    position: relative;
    z-index: 10;
  }
  @media (max-width: 996px) {
    .openAccountPart .leftShadow,
    .openAccountPart .rightShadow {
      display: none;
    }
    .openAccountPart .topShadow {
      position: absolute;
      opacity: 0.5;
      top: 0rem;
      width: 100vw;
      left: 0;
      height: 600rem;
    }
    .openAccountPart .bottomShadow {
      position: absolute;
      opacity: 0.5;
      bottom: 0rem;
      width: 100vw;
      left: 0;
      height: 600rem;
    }
    .openAccountPart {
      padding: 160rem 32rem;
    }
    .openAccountPart .cardList {
      flex-direction: column;
      gap: 32rem;
      align-items: normal;
    }
    .openAccountPart .cardList .card {
      flex: 1 0 auto !important;
      margin-inline: 0 !important;
      padding: 32rem 48rem;
      height: fit-content;min-height:172rem;
      border-radius: var(--ebc-corner-radius-rc16);
      background: var(--ebc-neutral-bg_a);
      justify-content: flex-start;
      gap: 32rem;
    }
    .openAccountPart .cardList .card .num {
      font-size: 105rem;
    }
    .openAccountPart .cardList .card svg {
      display: none;
    }
    .openAccountPart .iBtn {
      height: 80rem;
      font-size: 28rem;
      line-height: 0rem;
      margin: 80rem auto;
    }
  }
</style>